"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _base = _interopRequireDefault(require("base-64"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getInterceptor(_ref) {
  var lang = _ref.lang,
      siteInstance = _ref.siteInstance,
      locale = _ref.locale,
      isPrimaryLanguage = _ref.isPrimaryLanguage;

  var requestSuccess = function requestSuccess(config) {
    if (checkParameters({
      lang: lang,
      siteInstance: siteInstance,
      locale: locale,
      isPrimaryLanguage: isPrimaryLanguage
    })) {
      var instanceId;
      var encodedInstance = siteInstance.split('.')[1];

      try {
        instanceId = encodedInstance && JSON.parse(_base["default"].decode(encodedInstance)).instanceId;
      } catch (e) {}

      if (instanceId !== undefined) {
        config.headers['x-wix-linguist'] = [lang, locale, isPrimaryLanguage, instanceId].join('|');
      }
    }

    return config;
  };

  return {
    requestSuccess: requestSuccess
  };
}

function checkParameters(_ref2) {
  var lang = _ref2.lang,
      siteInstance = _ref2.siteInstance,
      locale = _ref2.locale,
      isPrimaryLanguage = _ref2.isPrimaryLanguage;

  if (/^(true|false)$/.test(isPrimaryLanguage)) {
    isPrimaryLanguage = isPrimaryLanguage.toString();
  } else {
    return false;
  }

  return lang && siteInstance && locale && isPrimaryLanguage;
}

var _default = {
  getInterceptor: getInterceptor
};
exports["default"] = _default;